var funcs = {
    guid: function() {
	if (Math && !Math.s4) {
            Math.s4 = function () {
		return Math.floor((1 + Math.random()) * 0x10000)
		    .toString(16).substring(1);
            };
	}
	var s4 = Math.s4;
	return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' +
	    s4() + s4() + s4();
    },

    makeid: function(N) {
	/* From https://stackoverflow.com/a/19964557 */
	var s = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
	return Array(N).join().split(',').map(function() { return s.charAt(Math.floor(Math.random() * s.length)); }).join('');
    },

    renderTmpl: function(tmplId, data)
    {
	var frm = $('#' + tmplId).html();
	if ( !('id' in data) ) data.id = funcs.guid();
	return nunjucks.renderString(frm, data);
    },

    collectFormVars: function($form, freshData)
    {
	if ( ! freshData ) freshData = {};
	var out = JSON.parse(JSON.stringify(freshData));
	console.groupCollapsed('%O: collectFormVars()', $form);
	$form.find(':input').each(function(i, el) {
	    var $el = $(el);
	    if ( ! $el.prop('name') ) {
		console.warn('No name for %O', $el);
		return;
	    }

	    var name = $el.prop('name');
	    var eltype = $el.prop('type');
	    var dtype = $el.data('type');
	    /* Skip these input types */
	    if ( eltype === 'file' ) return;
	    else if ( eltype === 'checkbox') {
		out[name] = $el.prop('checked') ? true : false;
	    } else if ( eltype === 'radio') {
		if ( $el.prop('checked') ) out[name] = $el.val();
            } else if ( dtype ) {
		/* Use the type from data="type" attribute on the
		 * element. Valid values for "type" include javascript
		 * types: "string", "number", etc. */
		var val = $el.val();
		if ( val ) {
		    switch(dtype) {
		    case "string": out[name] = val; break;
		    case "number": out[name] = parseInt(val.trim()); break;
		    case "float": out[name] = parseFloat(val.trim()); break;
		    case "boolean":
			out[name] = val.toLowerCase()==='true'?true:false;break;
		    default: throw 'Unsupported data="' + dtype + '"';
		    }
		} else {
		    var def = $el.data('default');
		    switch(dtype) {
		    case "string": if ( def ) out[name] = def; break;
		    case "number":
			if ( def ) out[name] = parseInt(def.trim()); break;
		    case "float":
			if ( def ) out[name] = parseFloat(def.trim()); break;
		    case "boolean":
			if ( def )
			    out[name] = def.toLowerCase()==='true'?true:false;
			break;
		    default: throw 'Unsupported data="' + dtype + '"';
		    }
		}
	    } else {
		/* Type processing: Use the type from the original
		 * source if available. If not (type is "undefined"),
		 * pick up the type from the element. */
		var val = $el.val();
		if ( val ) out[name] = val;
		else out[name] = null;
            }
	});
	console.groupEnd();
	return out;
    }

}

module.exports = funcs;
